var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { openMenu, closeMenu } from "../actions/contextMenuActions";

export class ContextMenu extends Component {
  render() {
    const children = React.Children.map(this.props.children, (child) => child) || [];
    let SubMenu = children.filter((child) => {
      const forceShow = this.props.overrideShow && this.props.show;
      const matchesType = child.type.name === this.props.type;
      const matchesWrap =
      child.type.WrappedComponent && child.type.WrappedComponent.name === this.props.type;
      return forceShow || matchesType || matchesWrap;
    });

    const position = `ContextMenu-${this.props.align || 'bottom'}`;

    SubMenu = React.Children.map(SubMenu, (child) => /*#__PURE__*/
    React.cloneElement(child, { active: this.props.open })
    );

    return /*#__PURE__*/(
      _jsx("div", {
        className: `ContextMenu ${position}`,
        onMouseEnter: this.props.openMenu,
        onMouseLeave: this.props.closeMenu,
        onClick: this.props.closeMenu }, void 0,

      SubMenu
      ));

  }
}















const mapStateToProps = (state) => state.contextMenu.toJS();

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ openMenu, closeMenu }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ContextMenu);